export default __webpack_public_path__ + "static/media/shieldbash.604b7e40.png";